module.exports = __webpack_public_path__ + "static/img/fgbg1-4.a8f2dff.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-4.png
// module id = 182
// module chunks = 0